import { ActionContext } from 'vuex';
import {IAppState} from "@/interfaces/app-state.interface";
import {IDashboard} from "@/modules/Dashboard/interfaces/dashboard.interface";
import {Vue} from "vue-property-decorator";
import {httpResource} from "@/resources/http.resource";


type DashboardContext = ActionContext<IDashboard.IState, IAppState>;

export const DashboardStore: DashboardContext = {
  // @ts-ignore
  namespaced: true,

  state: {
    waitingRequest: false,
    filters: {
      parks: [],
      tSumType: 1,
    },
    dashboards: null,
  },
  getters: {},
  mutations: {
    setPropertyInState(state: IDashboard.IState, { name, value }: { name: string, value: any }) { Vue.set(state, name, value); },
    setFilterParam(state: IDashboard.IState, { name, value }: { name: string, value: any }) { Vue.set(state.filters, name, value); },
    clearFilters(state: IDashboard.IState) {
      const props = [
        { prop: 'parks', value: [], },
        { prop: 'tSumType', value: 1, },
      ];
      props.forEach(item => Vue.set(state.filters, item.prop, item.value));
    },
  },

  actions: {
    async init({dispatch}: DashboardContext) {
      await dispatch('getDashboard');
    },

    async getDashboard({state, commit, dispatch}: DashboardContext, payload: { useFilter: boolean; }) {
      commit('setPropertyInState', { name: 'waitingRequest', value: true });
      let asyncAction = async () => {
        if (!payload) await dispatch('loadFiltersFromStorage');
        if (!state.filters.parks.length) return;

        let action = IDashboard.Action;
        let params: any = {...state.filters};
        let data = await httpResource.httpAction({ action, params });

        commit('setPropertyInState', { name: 'filters', value: data.data.result.filter });
        delete data.data.result.filter;

        commit('setPropertyInState', { name: 'dashboards', value: data.data.result });
      };

      await dispatch('defaultResourceAction', { asyncAction }, { root: true });
      commit('setPropertyInState', { name: 'waitingRequest', value: false });
    },

    async loadFiltersFromStorage({state, commit, rootGetters}: DashboardContext) {
      let storageFilters = localStorage.getItem(IDashboard.LocalStorageKeys.FilterValues);
      if (storageFilters) {
        let parsedFilters = JSON.parse(storageFilters);
        if (parsedFilters.types) delete parsedFilters.types;
        commit('setPropertyInState', { name: 'filters', value: parsedFilters });
      }
      if (!state.filters.parks.length) {
        let parksBook = rootGetters['book/parksBook'];
        if (parksBook.length === 1) {
          commit('setFilterParam', { name: 'parks', value: [parksBook[0].id] });
        }
      }
    },
  }
};
